var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogledrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.01999999999999999 -0.88 939.13 843.29",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2247,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M641.86 570.64H298.27l-147.13 257c17.7 9 37.8 14.77 50.8 14.77 135.16 0 411-2 547.93-2 14.08 0 27.26-4.8 39.08-12.32z",
    fill: "#4185f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.14 827.65l147.13-257H.13c-.15 17.86 6.2 34.2 16.15 52.84C44 675.35 90.9 758.25 118.45 801.55c6.79 10.67 33.75 26.64 32.69 26.1z",
    fill: "#1767d1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M641.86 570.64L789 828.05c19.07-12.12 34.61-31.32 44.7-49 22.78-39.87 61.3-106.26 87.87-151.21 12.35-20.9 17.15-39.67 16.85-57.22z",
    fill: "#e94235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.3 570.66L469.92 272.3 316.54 16.58c-16.59 10.91-30.78 25.72-37.22 37C212.37 171 77.5 411.65 9.68 530.59a73.54 73.54 0 0 0-9.59 40.07z",
    fill: "#30a753"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M641.85 570.66L469.92 272.3 619.09 16.87c16.59 10.92 34.8 25.43 41.24 36.72C727.28 171 862.15 411.65 930 530.59c7 12.23 9.11 26.07 8.43 40.07z",
    fill: "#f9bc00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.52 16.62l153.4 255.68L619.09 16.87c-15.4-9-37.21-14.33-58.33-15C502-.09 406.74-.88 355.47 1.35c-12.64.55-38.79 15.16-38.95 15.27z",
    fill: "#0f8038"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogledrive);
export default __webpack_public_path__ + "static/media/googledrive.c4dd53fe15cc3716ead8a696e22cd4c1.svg";
export { ForwardRef as ReactComponent };